import { pilot } from '~/services/serviceInstances';
import { PilotId } from '~/types/PilotId';

type Request = {
  folderId: PilotId;
  folderName: string;
  parentFolder: PilotId;
};

type ServerRequest = {
  folder_name: string;
  parent_folder: PilotId;
};

type Response = unknown;

export const renameFolder = async ({
  folderId,
  folderName,
  parentFolder,
}: Request): Promise<Response> => {
  const params: ServerRequest = {
    folder_name: folderName,
    parent_folder: parentFolder,
  };

  return pilot.put(`/folder/rename/${folderId}/`, params);
};
